
import type { FC } from 'react';
import { memo, useMemo } from 'react';
import { playAudio, parsingAI } from '@/utils/audioPlay';
import { IObjString, IAIDragQuestionProps, IlistItem } from '@/utils/ctype';
import DragAI from '../../../components/DragAI';
import DropAI from '../../../components/DropAI';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';



const Container: FC<IAIDragQuestionProps> = memo(function Container(props) {
  
  const { data, answerMap, groupId, type, isListen, keyIndex, answerAllText} = props;
  const { collect_option, list, question_title} = data || {};

  const {collectIdToContentMap, collectIdToTitleMap} = useMemo(() => {
    const collectIdToContentMap: IObjString = {};
    const collectIdToTitleMap :IObjString = {};
    collect_option.list.forEach((item) => {
      collectIdToTitleMap[item.id] = item.title;
      collectIdToContentMap[item.id] = item.content;
    }, {});
    return {collectIdToContentMap,collectIdToTitleMap };
  }, [collect_option.list]);

  const createAIType = (item: IlistItem, answer: string) => {
    const letter = collectIdToTitleMap[answer];
    // display_answer 为ABC 我拿到的answerData
    if (item?.display_answer === letter) {
      return 'success';
    } else {
      return 'fail';
    }
  };

  return (
    <div className={style.box}>
      <div className={style.content}>
        <div className={style.question}>
          <div className={style.questionTitle} data-key={`question.question.${keyIndex}.question_title`}><HtmlParser htmlString={question_title}></HtmlParser></div>
          {
            list.map((item, index: number) => {
              const key = `${groupId}_${type}_${item.id}`;
              const answer = answerMap[key] && answerMap[key][0];
              const resultType = createAIType(item, answer);
              return (
                <div className={style.questionItem} key={index}>
                  <span className={style.questionText} data-key={`question.question.${keyIndex}.list.${index}.title`}><HtmlParser htmlString={item.title}></HtmlParser></span>
                  <div className={style.blankBox}>
                    <DropAI 
                      data={item} 
                      type={resultType} 
                      answer={answerAllText[item.number - 1] || collectIdToContentMap[answer]} 
                      dataKey={`question.question.${keyIndex}.list.${index}.display_answerHtml`} 
                      answerKey={`answerAllText.${item.number - 1}`} 
                      playAudio={()=> {playAudio(item);}} 
                      parsingAI={() => {parsingAI(item);}} isListen={isListen}
                      id={`question${item.number}`}/>
                  </div>
                </div>
              );
            })
          }
        </div>

        <div className={style.answer}>
          <div className={style.optionTitle} data-key={`question.question.${keyIndex}.collect_option.title`}><HtmlParser htmlString={collect_option.title}></HtmlParser></div>
          {
            collect_option.list.map((item, index: number) => (
              <div className={style.answerItem} key={index}>
                <DragAI 
                  data={item} 
                  dataKey={`question.question.${keyIndex}.collect_option.list.${index}.content`} 
                  titleKey={`$question.question.${keyIndex}.collect_option.list.${index}.title`} 
                ></DragAI>
              </div>
            ))
          }
        </div>
      </div>
      
    </div>
  );
});

export default Container;